(function () {
	'use strict';

	angular
	.module('core')
	.controller('dataCtrl', dataCtrl);

	dataCtrl.$inject = ['$http', '$scope', '$rootScope', '$q', '$timeout', '$route', 'Upload'];

	function checkString(needle, haystack){
		var _return = false;

		if(typeof needle == 'string'){
			_return = haystack.indexOf(needle) >= 0;
		}
		else {
			$(needle).each(function(){
				if(haystack.indexOf(this) >= 0){
					_return = true;
				}
			})
		}

		return _return
	}

	function shadeColor(color, percent) {   
	    var f=parseInt(color.slice(1),16),t=percent<0?0:255,p=percent<0?percent*-1:percent,R=f>>16,G=f>>8&0x00FF,B=f&0x0000FF;
	    return "#"+(0x1000000+(Math.round((t-R)*p)+R)*0x10000+(Math.round((t-G)*p)+G)*0x100+(Math.round((t-B)*p)+B)).toString(16).slice(1);
	}

	function dummyData(){
		var _length = 20;
		var _data = [];

		for(var i=0; i<_length; i++){
			_data.push([i, randFloat(20,100)]);
		}
		return _data;
	}

	function dataCtrl($http, $scope, $root, $q, $timeout, $route, $upload) {
		var vm = $scope;
		$root.loading = true;
		vm.selectedPerson;
		vm.countries = [];
		vm._all = 'All';
		vm._any = 'Any';
		$root.searchTerms = '';
		$root.countryAll = true;

		$root.tags = [];

		$root.project = $route.current.params.project;

		vm.chartApi = {};
		vm.chartData = [{
			values: dummyData(),
			area: true
		}];

		vm.lightenColor = function(_color){
			return shadeColor(_color, .85);
		}

		vm.recurseEnd = function(index){
			var _recursive = false;
			if(vm.journey != undefined && vm.journey[index] != undefined){
				var _name = vm.journey[index].name.toLowerCase();

				angular.forEach(vm.journey, function(_journey, _index){
					if(_journey.recurseTo != undefined && _journey.recurseTo.toLowerCase() == _name){
						_recursive = _index - index;
					}
				});
			}
			return _recursive;
		}

		vm.tagName, vm.tagFocused;

		vm.selectTag = function(tag, person){
			if($root.tags.indexOf(tag) < 0){
            	$root.tags.push(tag);
            }

			if(person.tags == undefined){
        		person.tags = [];
        	}
        	if($root.selectedText || $root.highlight){
            	person.tags.push({
            		'tag':tag,
            		'content':$root.selectedText ? $root.selectedText : $root.highlight
            	});
            	$root.highlight = '';
            }
            else {
            	person.tags.push({
            		'tag':tag
            	})
            }
		}

		vm.tagKey = function(event, value, person){
			$timeout(function(){
				switch(event.key){
	                case 'Enter':

	                if($root.tags.indexOf(value) < 0){
	                	$root.tags.push(value);
	                }
	                vm.selectTag(value, person);

	                value = '';
	                $(event.target).trigger('blur');
	                $root.tagName = '';
	                break;
	            }
			})
        }

		vm.chartOptions = {
			'chart':{
				type: 'lineChart',
				margin : {
					top: 0,
					right: 0,
					bottom: 0,
					left: 0
				},
				x: function(d){ return d[0]; },
				y: function(d){ return d[1]/100; },
				average: function(d) { return d.mean/100; },
				interpolate: 'basis',
				showLegend: false,
				showYAxis: false,
				showXAxis: false,
				showValues: false,
				interactive: false,
				yDomain: [0,1],
				duration: 1000,
				useInteractiveGuideline: false,
				tooltip:{
					enabled: false
				},
				clipVoronoi: false,
				showControls: false,
				color: ['#dcecf6']
			}
		}

		vm.chartReady = function(scope, elem){
			//vm.chartApi = scope.api;
		}

		$root.screen = 'participants';

		vm.$on('documentClick', function(){
			vm.showCountry = false;
			angular.forEach(vm.filters, function(filter){
				filter.show = false;
			});
		});

		vm.getExport = function(){
			var _data = {};
			angular.forEach(vm.groups, function(group){
				angular.forEach(group.topics, function(topic){
					if(topic.checked == true){
						if(_data[group.name + ' - ' + topic.id] == undefined){
							_data[group.name + ' - ' + topic.id] = []
						}
						_data[group.name + ' - ' + topic.id].push(["Group", "User", "Country", "Response"]);
						angular.forEach(group.participants, function(participant){
							if(participant.topics != undefined && participant.topics[topic.id] != undefined){
								angular.forEach(participant.topics[topic.id], function(reply){
									if(reply.Role == 'participant' && reply.Reply != '' && reply.Reply != undefined){
										_data[group.name + ' - ' + topic.id].push([group.name, participant.Handle, participant.country ? participant.country.name :'', reply.Reply]);
									}
								});
							}
						});
					}
				});
			});

			$http.post('./services/download.php', _data).then(function(ret){
				window.location.href = './download.php?file='+ret.data.file;
			});
		}

		$root.lastUpdated = function(){
			var difference = parseInt((new Date()).getTime()/1000) - vm.updated;
			var time = Math.ceil(difference/60);
			return time;
		}

		vm.anyExports = function(){
			var _return = false;

			angular.forEach(vm.groups, function(group){
				if(group.topics != undefined){
					angular.forEach(group.topics, function(topic){
						if(topic.checked){
							_return = true;
						}
					});
				}
			});

			return _return;
		}

		vm.getTotal = function(_type){
			var _personal = [];
			var _doc = [];
			var _pallet = [];

			angular.forEach(vm.getUsers(), function(user){
				if(user.group != undefined && vm.count(user.Topics) >= (vm.count(user.group.topics) - 1)) {
					if(user.group.name == 'DHL Pallet/Cargo/Freight Rate Quote Group'){
						_pallet.push(user);
					}
					else if(user.group.name == 'DHL Document/Package Rate Quote Group') {
						_doc.push(user);
					}
					else if(user.group.name == 'DHL Personal Rate Quote Group') {
						_personal.push(user);
					}
				}
			});

			switch(_type){
				case 'personal':
				return _personal.length
				break;

				case 'doc':
				return _doc.length
				break;

				case 'pallet':
				return _pallet.length
				break;
			}

			return 0;
		}

		vm.getUsers = function(){
			var _users = [];
			var _country;
			if(arguments.length > 0){
				_country = arguments[0];
			}
			angular.forEach(vm.groups, function(group){
				angular.forEach(group.participants, function(user){
					if(_country == undefined || user.country.code == _country.code){
						_users.push(user);
					}
				});
			});
			return _users;
		}

		vm.personalFilter = function(user){
			var _return = false;
			if(vm.count(user.topics) >= (vm.count(user.group.topics) - 1) && user.group != undefined && user.group.name == 'DHL Personal Rate Quote Group') {
				_return = true;
			}

			return _return;
		}
		vm.docFilter = function(user){
			var _return = false;
			if(vm.count(user.Topics) >= (vm.count(user.group.topics) - 1) && user.group != undefined && user.group.name == 'DHL Document/Package Rate Quote Group') {
				_return = true;
			}

			return _return;
		}
		vm.palletFilter = function(user){
			var _return = false;
			if(vm.count(user.Topics) >= (vm.count(user.group.topics) - 1) && user.group != undefined && user.group.name == 'DHL Pallet/Cargo/Freight Rate Quote Group') {
				_return = true;
			}

			return _return;
		}

		vm.countryTotal = function(_country){
			var _personal = [];
			var _doc = [];
			var _pallet = [];

			angular.forEach(vm.getUsers(_country), function(user){
				if(user.group != undefined && vm.count(user.Topics) >= (vm.count(user.group.topics) - 1)) {
					if(user.group.name == 'DHL Pallet/Cargo/Freight Rate Quote Group'){
						_pallet.push(user);
					}
					else if(user.group.name == 'DHL Document/Package Rate Quote Group') {
						_doc.push(user);
					}
					else if(user.group.name == 'DHL Personal Rate Quote Group') {
						_personal.push(user);
					}
				}
			});
			return {
				'personal': _personal.length,
				'doc': _doc.length,
				'pallet': _pallet.length,
				'total': _personal.length + _doc.length + _pallet.length
			}
		}

		vm.setFilters = function(_values){
			var _keys = Object.keys(_values);
			angular.forEach(vm.filters, function(filter){
				if(_keys.exists(filter.slug)) {
					angular.forEach(filter.items, function(item){
						if(_values[filter.slug].exists(item.value) || _values[filter.slug].exists(item.name)){
							item.checked = true;
						}
						else {
							item.checked = false;
						}
					})
				}
			});
			$timeout(function(){
				$root.screen = "participants";
			}, 250);
		}

		vm.filters = {
			'groups':{
				'slug':'groups',
				'title':'Groups',
				'items':[]
			},
			'countries':{
				'slug':'countries',
				'title':'Countries',
				'items':[]
			},
			'topics':{
				'slug':'topics',
				'title':'Topics',
				'items':[
					{
						'value':'0',
						'name':'No topics answered',
						'check':function(user){
							return user.topics == undefined || vm.topicsCompleted(user) == 0;
						}
					},{
						'value':'some',
						'name':'Some topics answered',
						'check':function(user){
							return (vm.topicsCompleted(user) < vm.requiredTopics(user) && vm.topicsCompleted(user) > 0);
						}
					},{
						'value':'all',
						'name':'All topics answered',
						'check':function(user){
							return vm.topicsCompleted(user) >= vm.requiredTopics(user);
						}
					}
				]
			},
			'followups':{
				'slug':'followups',
				'title':'Followups',
				'items':[
					{
						'value':'0',
						'name':'No followups answered',
						'check':function(user){
							return user.followUps.questions != 0 && user.followUps.replies == 0;
						}
					},{
						'value':'some',
						'name':'Some followups answered',
						'check':function(user){
							return user.followUps.questions != 0 && user.followUps.replies != 0 && user.followUps.replies < user.followUps.questions;
						}
					},{
						'value':'all',
						'name':'All followups answered',
						'check':function(user){
							return user.followUps.questions != 0 && user.followUps.replies >= user.followUps.questions;
						}
					},{
						'value':'no',
						'name':'No followups asked',
						'check':function(user){
							return user.followUps.questions == 0 || user.followUps.questions == undefined;
						}
					}
				]
			},
			'incentives':{
				'slug':'incentives',
				'title':'Incentive',
				'items':[
					{
						'value':'delivered',
						'name':'Email Delivered',
						'check':function(user){
							return user.incentive != undefined && user.incentive.status == 'Email Delivered';
						}
					},{
						'value':'opened',
						'name':'Email Opened',
						'check':function(user){
							return user.incentive != undefined && user.incentive.status == 'Email Opened';
						}
					},{
						'value':'claimed',
						'name':'Gift Claimed',
						'check':function(user){
							return user.incentive != undefined && user.incentive.status == 'Gift Claimed';
						}
					},{
						'value':'none',
						'name':'No incentive',
						'check':function(user){
							return user.incentive == undefined;
						}
					}
				]
			},
			'sources':{
				'slug':'sources',
				'title':'Source',
				'items':[
					{
						'value':'quote',
						'name':'Get Quote',
						'check':function(user){
							return user.source == 'getquote';
						}
					},{
						'value':'contact',
						'name':'Contact Us',
						'check':function(user){
							return user.source == 'contactus';
						}
					},{
						'value':'respondent',
						'name':'Respondent.io',
						'check':function(user){
							return user.source == 'respondent.io';
						}
					},{
						'value':'unknown',
						'name':'Unknown',
						'check':function(user){
							return user.source == undefined || user.source == '';
						}
					}
				]
			},
			// 'dates':{
			// 	'slug':'dates',
			// 	'title':'Completed',
			// 	'items':[
			// 		{
			// 			'value':'week',
			// 			'name':'Over a week',
			// 			'check':function(user){
			// 				var _time = (new Date()).getTimezoneOffset() + parseInt((new Date()).getTime()/1000);
			// 				return user.LastUpdated.timestamp < (_time - (60*60*24*7));
			// 			}
			// 		},{
			// 			'value':'threeToSeven',
			// 			'name':'3 to 7 days',
			// 			'check':function(user){
			// 				var _time = (new Date()).getTimezoneOffset() + parseInt((new Date()).getTime()/1000);
			// 				return user.LastUpdated.timestamp >= (_time - (60*60*24*7)) && user.LastUpdated.timestamp < (_time - (60*60*24*3));
			// 			}
			// 		},{
			// 			'value':'threeFewer',
			// 			'name':'3 or fewer days',
			// 			'check':function(user){
			// 				var _time = (new Date()).getTimezoneOffset() + parseInt((new Date()).getTime()/1000);
			// 				return user.LastUpdated.timestamp >= (_time - (60*60*24*3));
			// 			}
			// 		}
			// 	]
			// },
			'service':{
				'slug':'service',
				'title':'Service',
				'items':[]
			}
		}

		vm.tagHighlight = function(content){
			$root.highlight = content;
			$root.highlightEdit = false;
			$timeout(function(){
				if($('.user-details .highlighted').length > 0){
					var _top = ($('.user-details').scrollTop() + $('.user-details .highlighted').first().offset().top)-$('.user-details').offset().top - parseFloat($('.user-details').css('padding-top'));
					$('.user-details').animate({'scrollTop':_top}, 500);
				}
			}, 250);
		}

		vm.anyFilters = function(){
			var _anyFilter = false;
			angular.forEach(vm.filters, function(filter){
				angular.forEach(filter.items, function(item){
					if(item.checked == true){
						_anyFilter = true;
					}
				});
			});

			return _anyFilter;
		}
		vm.clearFilters = function(){
			angular.forEach(vm.filters, function(filter){
				angular.forEach(filter.items, function(item){
					item.checked = false;
				});
			});
		}

		vm.getChecked = function(_objects, _val, _default, _all){
			var _return = [];

			angular.forEach(_objects, function(_object){
				if(_object.checked == true){
					_return.push(_object);
				}
			});

			return _return;
		}

		vm.addFilter = function(){
			$root.modal = true;
			vm.showFilters = true;
		}

		vm.toggleChecked = function(_array){
			if(vm.getChecked(_array).length == 0){
				vm.checkAll(_array);
			}
			else {
				vm.uncheckAll(_array);
			}
		}

		vm.toggleAll = function(_array){
			$timeout(function(){
				angular.forEach(_array, function(_item){
					_item.checked = _item.checked != undefined ? !_item.checked : true;
				});
			});
		}

		vm.checkAll = function(_array){
			$timeout(function(){
				angular.forEach(_array, function(_item){
					_item.checked = true;
				});
			});
		}
		vm.uncheckAll = function(_array){
			$timeout(function(){
				angular.forEach(_array, function(_item){
					_item.checked = false;
				});
			});
		}

		vm.select = function(_person){
			if(_person.Topics != undefined){
				_person.tab = 'focusgroup';
			}
			else if(_person['Survey Gizmo'] != undefined){
				_person.tab = 'gizmo';
			}
			else if(_person['Respondent.io'] != undefined){
				_person.tab = 'respondent';
			}
			else if(_person.details != undefined){
				_person.tab = 'details';
			}
			vm.selectedPerson = _person;
			$root.modal = true;
		}
		vm.deselect = function(){
			$root.modal = false;
			$timeout(function(){
				vm.selectedPerson = null;
			}, 500);
		}

		vm.count = function(_obj){
			var _count = 0;
			if(_obj != undefined){
				_count = Object.keys(_obj).length;
			}
			return _count;
		}

		vm.hasReplies = function(topic){
			var _return = false;

			if(topic.Reply != undefined && topic.Reply != ''){
				_return = true;
			}

			return _return;
		}

		vm.hideFilters = function(except){
			angular.forEach(vm.filters, function(filter){
				if(!angular.equals(filter, except)){
					filter.show = false;
				}
			});
		}

		vm.userFilters = function(user){
			var _return = true;
			var _tmp = {};

			angular.forEach(vm.filters, function(filter){
				var _any = false;
				_tmp[filter.slug] = false;

				angular.forEach(filter.items, function(item){
					if(item.checked == true){
						_any = true;
						if(item.check(user)){
							_tmp[filter.slug] = true;
						}
					}
				});

				if(!_any){
					_tmp[filter.slug] = true;
				}
			});

			if($root.searchTerms != undefined && $root.searchTerms != ''){
				_tmp.search = false;
				var _terms = $root.searchTerms.toLowerCase();

				angular.forEach(user.Topics, function(replies){
					angular.forEach(replies, function(reply){
						if(reply.Reply != undefined && reply.Role == 'participant'){
							var _text = reply.Reply;
							if(typeof _text == 'string' && _text.length > 0){
								_text = _text.toLowerCase();

								if(_text.indexOf(_terms) >= 0){
									_tmp.search = true;
								}
							}
						}
					});
				});
			}

			angular.forEach(_tmp, function(filter){
				if(filter == false){
					_return = false;
				}
			});

			return _return;
		}

		vm.initPerson = function(_person, _group){
			var _topics = {};
			angular.forEach(_group.topics, function(topic){
				var _replies = [];
				angular.forEach(topic.replies, function(reply){
					if(reply.handle == _person.Handle){
						_replies.push(reply);
					}
				});
				if(_replies.length > 0){
					_topics[topic.value] = _replies;
				}
			});
			_person.topics = _topics;

			vm.setFollowUps(_person);
		}

		vm.checkReplies = function(msg){
			var _questions = 0;
			var _replies = 0;

			if(msg.replies != undefined){
				angular.forEach(msg.replies, function(reply){
					var tmp;
					if(reply.user_type != undefined && reply.user_type.toLowerCase() == 'moderator'){
						_questions = _questions + 1;
						tmp = vm.checkReplies(reply);
						_replies = _replies + tmp.replies;
					}
					else {
						_replies = _replies + 1;
						tmp = vm.checkReplies(reply);
						_questions = _questions + tmp.questions;
					}
				});
			}

			return {
				'questions': _questions,
				'replies': _replies
			}
		}

		vm.setFollowUps = function(_person){
			_person.followUps = {
				questions: 0,
				replies: 0
			}
			if(_person.topics != undefined){
				angular.forEach(_person.topics, function(topic){
					if(topic != undefined && topic.length > 0){
						angular.forEach(topic, function(reply){
							var tmp = vm.checkReplies(reply);
							
							_person.followUps.questions = _person.followUps.questions + tmp.questions;
							_person.followUps.replies = _person.followUps.replies + tmp.replies;
						})
					}
				})
			}
		}

		vm.topicsCompleted = function(user){
			var _userTopics = [];

			if(user.group != undefined && user.group.id != undefined){
				angular.forEach(vm.getTopics(user.group.id), function(topic){
					if(topic.title != 'Welcome' && topic.title != 'Closing'){
						if(user.topics != undefined && user.topics[topic.id] != undefined){
							_userTopics.push(topic.id);
						}
					}
				});
			}
			
			
			return _userTopics.length;
		}
		vm.requiredTopics = function(user){
			var _topics = [];

			if(user.group != undefined && user.group.id != undefined){
				angular.forEach(vm.getTopics(user.group.id), function(topic){
					if(topic.title != 'Welcome' && topic.title != 'Closing'){
						_topics.push(topic.id);
					}
				});
			}

			return _topics.length;
		}

		vm.upload = function(_files) {
			var _queue = [];

			if(arguments.length > 1){
				var key = arguments[1];
				$root.stores[key].dragging = false;
			}
			else {
				var key = $root.newStore();
			}
			
			$root.files[key].files = $root.files[key].files.concat(_files);

			var files = $root.files[key].files;

			if (files && files.length) {
				if(key == $root.currentStore && $root.files[key].detailsSeen !== true){
					$root.stores[key] = {
						'files':$root.files[key],
						'uploads':$root.uploads[key],
						'hash':key,
						'started': (new Date()),
						'date':$root.getDate(),
						'status': 'Uploading',
						'storeIndex':$root.indexer++
					}
					$root.showModal('set-details');
					$root.files[key].detailsSeen = true;
				}

				vm.processing = true;
				$(files).each(function(){
					var file = this;
					if (!file.$error && $root.uploads[key][file.name] == undefined) {
						$root.uploads[key][file.name] = {}
						var _data = {
							"file": file
						};
						_data[$('#phpUpload').attr('name')] = file.name.toLowerCase()
						_queue.push($upload.upload({
							url: './services/upload.php',
							data: _data
						}).then(function (resp) {
							$root.uploads[key][file.name].key = file.name;
							$root.uploads[key][file.name].completed = true;
							$root.uploads[key][file.name].data = './tmp/' + resp.data;
							$root.uploads[key][file.name].sets = {}
						}, null, function (evt) {
							$root.uploads[key][file.name] = evt
						}));
					}
				});

				$root.setRandomOrders(key);
				$root.setRandomCustomers(key);
				$root.setRandomMessages(key);

				$q.all(_queue).then(function(){
					vm.processing = false;

					$http.post('./services/organize.php', Object.keys($root.uploads[key])).then(function(ret){
						$root.stores[key].sets = ret.data.sets;
						$root.stores[key].people = ret.data.people;
						
						$(Object.keys(ret.data.files)).each(function(index){
							$root.uploads[key][this].sets = angular.copy(ret.data.files[this].sets);
							$root.uploads[key][this].people = angular.copy(ret.data.files[this].people);
							$root.uploads[key][this].exif = angular.copy(ret.data.files[this]);
							delete $root.uploads[key][this].exif.sets;
							delete $root.uploads[key][this].exif.people;
						});
					});

					$timeout.cancel($root.files[key].timer);
					$root.files[key].timer = $timeout(function(){
						vm.checkComplete(key);
					}, 1000);
				});
			}
		};

		$root.count = vm.count;

		vm.$watch(function(){
			var text = "";
			if (window.getSelection) {
				text = window.getSelection().toString();
			} else if (document.selection && document.selection.type != "Control") {
				text = document.selection.createRange().text;
			}
		    return text;
		}, function(newVal){
			$root.selectedText = newVal;
			if(newVal != ''){
				$root.highlight = newVal;
				$root.highlightEdit = true;

				$timeout.cancel($root.highlightTimer);

				$root.highlightTimer = $timeout(function(){
					$root.highlightLeft = '';
					$root.highlightTop = '';
					if($('.user-details .highlighted').length > 0){
						var _top = ($('.user-details').scrollTop() + $('.user-details .highlighted').first().offset().top)-$('.user-details').offset().top + $('.user-details .highlighted').first().outerHeight();
						var _left = $('.user-details .highlighted').first().position().left;

						$root.highlightLeft = _left+'px';
						$root.highlightTop = _top+'px';
						
						var _top = ($('.user-details').scrollTop() + $('.user-details .highlighted').first().offset().top)-$('.user-details').offset().top - parseFloat($('.user-details').css('padding-top'));
						$('.user-details').animate({'scrollTop':_top}, 500);
					}

					$timeout(function(){
						$('.tag-modal input').focus();
					}, 50);
				}, 50);
			}
		})

		vm.getTopics = function(groupId){
			var _topics = {};
			angular.forEach(vm.groups, function(group){
				if(groupId != undefined && groupId == group.id){
					_topics = group.topics;
				}
			})
			return _topics;
		}

		vm.loadParticipants = function(response){
			vm.updated = response.data.time; 
			vm.groups = response.data.groups;

			var _queue = [];

			$root.loadingReason = 'Replies';

			angular.forEach(vm.groups, function(group){
				angular.forEach(group.topics, function(topic){
					var _get = $http.get('./services/replies.php?project='+$root.project+'&group='+group.id+'&question='+topic.id);
					
					_queue.push(_get);

					_get.then(function(topicR){
						topic.replies = topicR.data;
					})
				});

				var _group = {
					'name':group.name,
					'value':group.name.toSlug(),
					'check':function(user){
						return user.group.name == group.name;
					}
				}

				if(!vm.filters.groups.items.exists(_group)){
					vm.filters.groups.items.push(_group);
				}
			});
			
			$q.all(_queue).then(function(){
				$timeout(function(){
					angular.forEach(vm.groups, function(group){
						angular.forEach(group.participants, function(person){
							var _country = angular.copy(person.country);
							_country.value = _country.code;
							_country.check = function(user){
								return user.country.code != undefined && user.country.code == _country.code;
							}
							if(!vm.filters.countries.items.exists(_country)){
								vm.filters.countries.items.push(_country);
							}
							if(person.details != undefined && person.details['DHL Service'] != undefined){
								var _name = angular.copy(person.details['DHL Service']);
								var _service = {
									'name':_name,
									'value':_name.toSlug(),
									'check':function(user){
										return user.details != undefined && user.details['DHL Service'] != undefined && user.details['DHL Service'] == _name;
									}
								}
								if(!vm.filters.service.items.exists(_service)){
									vm.filters.service.items.push(_service);
								}
							}

							var _topics = {};
							angular.forEach(group.topics, function(topic){
								var _replies = [];
								angular.forEach(topic.replies, function(reply){
									if(reply.handle == person.Handle){
										_replies.push(reply);
									}
								});
								if(_replies.length > 0){
									_topics[topic.id] = _replies;
								}
							});
							person.group = {
								'id':group.id,
								'name':group.name
							}
							person.topics = _topics;

							vm.setFollowUps(person);
						})
					});

					$root.loading = false;
					delete $root.loadingReason;

				}, 250);
			});

			var _service = {
				'name':'Unknown',
				'value':'unknown',
				'check':function(user){
					return user.details == undefined || user.details['DHL Service'] == undefined;
				}
			}
			if(!vm.filters.service.items.exists(_service)){
				vm.filters.service.items.push(_service);
			}
		}

		vm.updateData = function(){
			$root.loading = true;
			$http.get('./services/temp.php?project='+$root.project+'&t='+(new Date()).getTime()+'&reset', {
				headers: {
					'Content-Type' : 'application/json; charset=UTF-8'
				}
			}).
			then(vm.loadParticipants);
		}

		vm.init = function() {
			$root.loadingReason = 'Data';

			$http.get('./services/temp.php?project='+$root.project+'&t='+(new Date()).getTime(), {
				headers: {
					'Content-Type' : 'application/json; charset=UTF-8'
				}
			}).
			then(vm.loadParticipants);
		}
		vm.init();
	}
})();